import React, { useCallback } from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { setDefaultFilterItems } from '../../common/src/actions/filtersActions'
import { useTranslation } from 'react-i18next'
import { isMobile as isMobilePlatform } from '../../common/src/helpers/platformHelper'

const ContainerPlaceholder = styled.div`
  display: flex;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  margin: 8px;
`

const Placeholder = styled.div`
  width: 75%;
  color: ${p => p.theme.palette.neutralSecondary};
  cursor: pointer;
`

export const QuadrantPlaceholder = React.memo(({ count, isFiltering = false, readOnly = false }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const isMobile = isMobilePlatform()
  const isFilterPlaceholder = count === 0 && isFiltering

  const getTextPlaceholder = (isFilterPlaceholder, isMobile) => {
    if (isMobile) {
      return isFilterPlaceholder ? t('quadrant.filter_placeholder_mobile') : t('quadrant.add_item_placeholder_mobile')
    } else {
      return isFilterPlaceholder ? t('quadrant.filter_placeholder') : t('quadrant.add_item_placeholder')
    }
  }

  const text = getTextPlaceholder(isFilterPlaceholder, isMobile)

  const showPlaceholder = isFilterPlaceholder || !readOnly

  const onClickFilterPlaceholder = useCallback(
    event => {
      dispatch(setDefaultFilterItems())

      event.preventDefault()
      event.stopPropagation()
    },
    [dispatch]
  )

  const onClick = isFilterPlaceholder ? onClickFilterPlaceholder : null
  return (
    <ContainerPlaceholder>
      {showPlaceholder && <Placeholder onClick={onClick}>{text}</Placeholder>}
    </ContainerPlaceholder>
  )
})
